module.exports = __webpack_public_path__ + "img/luna - 에볼루션.f42e67eb.png";